import { useNavigate } from 'react-router-dom';

import { NavigationService } from '../../services/navigation.service';

import { UserUmanforge } from '@umanforge/common';

import DefaultAvatar from '../../assets/default_avatar.png';
import { LockIcon } from '../icons/lock_icon.component';
import { BanIcon } from '../icons/ban_icon.component';


interface UserProps {
  user: UserUmanforge;
  t: ( key: string ) => string;
  avatarUrl?: string | null;
}

export function UserComponent( props: UserProps ) {
  const { user, avatarUrl } = props;

  const navigate = useNavigate();

  function openDetailsUser() {
    NavigationService.toUser( navigate, user.id, false );
  }

  return (
    <div
      className="my-4 shrink-0 text-center bg-white/50 shadow-md drop-shadow-md mx-2 flex overflow-hidden rounded-lg cursor-pointer transition ease-in-out hover:-translate-y-1 hover:scale-[105%] hover:drop-shadow-xl hover:z-10 duration-50"
      style={{ width: '26rem' }}
      onClick={ openDetailsUser }
    >
      <div className={
        'h-full flex flex-col w-1/3 pb-2 place-content-between '
        + ( user.isLock ? 'bg-red-500' : ( user.isDisable ? 'bg-amber-500' : 'bg-blue-400' ) )
      }>
        <div className="h-full flex justify-center">
          <div className="flex justify-center rounded-full bg-white h-16 w-16 relative shadow-md my-2 overflow-hidden">
            {
              user.isLock ?
                <LockIcon className='flex justify-center items-center w-full h-full bg-gray-200 opacity-70 z-10 p-5 fill-red-500'/>
                :
                user.isDisable ?
                  <BanIcon className='flex justify-center items-center w-full h-full bg-gray-200 opacity-70 z-10 p-5 fill-amber-500'/>
                  :
                  null
            }
            <img
              src={ avatarUrl || DefaultAvatar }
              draggable="false"
              className="absolute w-full h-full flex justify-center items-center select-none rounded-full object-cover"
              alt={user.fullname}
            />
          </div>
        </div>
        <p className="p-1 h-full text-md text-white font-medium text-center">
          {user.fullname}
        </p>
      </div>

      <div className="flex flex-col h-full w-2/3 items-center justify-center bg-slate-100 p-2">
        <p className="text-md text-slate-500 text-center">{user.email}</p>
      </div>
    </div>
  );
}